import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { serverUrl } from "../nestserver";

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
});

export const DAY_PERMISSION_KEY = "student-day-permission";

/** List day permissions (role-scoped on the server). */
export function useGetDayPermissions(params = {}, queryOptions = {}) {
  async function fetchList() {
    const res = await axios.get(`${serverUrl}/student-day-permission`, {
      headers: authHeaders(),
      params,
    });
    return res.data?.result?.data || [];
  }
  return useQuery([DAY_PERMISSION_KEY, params], fetchList, queryOptions);
}

export function useCreateDayPermission(mutationOptions) {
  return useMutation(
    (data) =>
      axios.post(`${serverUrl}/student-day-permission`, data, {
        headers: authHeaders(),
      }),
    mutationOptions,
  );
}

export function useUpdateDayPermissionStatus(mutationOptions) {
  return useMutation(
    ({ id, status, admin_notes }) =>
      axios.patch(
        `${serverUrl}/student-day-permission/${id}/status`,
        { status, admin_notes },
        { headers: authHeaders() },
      ),
    mutationOptions,
  );
}

export function useWithdrawDayPermission(mutationOptions) {
  return useMutation(
    (id) =>
      axios.patch(
        `${serverUrl}/student-day-permission/${id}/withdraw`,
        {},
        { headers: authHeaders() },
      ),
    mutationOptions,
  );
}

export const DAY_PERMISSION_TYPES = [
  { value: "check_in", label: "Late arrival" },
  { value: "check_out", label: "Early pickup" },
  { value: "both", label: "Flex (step out / both)" },
];

export const dayPermissionLabel = (value) =>
  DAY_PERMISSION_TYPES.find((t) => t.value === value)?.label || value;
